import { render, staticRenderFns } from "./suffixIcon-editor.vue?vue&type=template&id=3918f2ba&scoped=true"
import script from "./suffixIcon-editor.vue?vue&type=script&lang=js"
export * from "./suffixIcon-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3918f2ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3918f2ba')) {
      api.createRecord('3918f2ba', component.options)
    } else {
      api.reload('3918f2ba', component.options)
    }
    module.hot.accept("./suffixIcon-editor.vue?vue&type=template&id=3918f2ba&scoped=true", function () {
      api.rerender('3918f2ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/suffixIcon-editor.vue"
export default component.exports